/** Адрес возврата после входа: только путь того же origin. Всё остальное
 *  («//evil», обратные слэши, абсолютные URL, сама страница входа) → «/». */
export function safeReturn(raw: string | undefined, origin: string = window.location.origin): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.includes("\\")) return "/";
  try {
    const u = new URL(raw, origin);
    if (u.origin !== origin || u.pathname.startsWith("/login")) return "/";
    return u.pathname + u.search + u.hash;
  } catch {
    return "/";
  }
}
